function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 71,
    viewBox: "0 0 72 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.757812,
    width: 70.7174,
    height: 70.7174,
    rx: 12.1927,
    fill: "#639FF0",
    style: {
      fill: "#639FF0",
      fill: "color(display-p3 0.3882 0.6235 0.9412)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1172 30.8568H52.1172M42.1172 30.8568V49.1901M42.1172 30.8568H32.1172M52.1172 30.8568V45.8568C52.1172 47.4284 52.1172 48.2134 51.6289 48.7018C51.1405 49.1901 50.3555 49.1901 48.7839 49.1901H42.1172M52.1172 30.8568V25.8568C52.1172 24.2851 52.1172 23.5001 51.6289 23.0118C51.1405 22.5234 50.3555 22.5234 48.7839 22.5234H25.4505C23.8789 22.5234 23.0939 22.5234 22.6055 23.0118C22.1172 23.5001 22.1172 24.2851 22.1172 25.8568V30.8568M52.1172 30.8568H22.1172M42.1172 49.1901H32.1172M22.1172 30.8568H32.1172M22.1172 30.8568V45.8568C22.1172 47.4284 22.1172 48.2134 22.6055 48.7018C23.0939 49.1901 23.8789 49.1901 25.4505 49.1901H32.1172M32.1172 30.8568V49.1901",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.298b4184cce6c242a5b104b31f83d1b0.svg";
export { ForwardRef as ReactComponent };